export default __webpack_public_path__ + "img/bTPMDUdR.2ba02f67.svg";